import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/utils';
import '@archetype-themes/scripts/helpers/delegate';

// Either collapsible containers all acting individually,
// or tabs that can only have one open at a time
theme.collapsibles = (function() {
  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner',
    tabs: '.collapsible-trigger--tab'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height',
    tabs: 'collapsible-trigger--tab'
  };

  var namespace = '.collapsible';
  var isTransitioning = false;

function init(scope) {
  var el = scope ? scope : document;
  el.querySelectorAll('.collapsible-trigger').forEach(trigger => {
    // Explicitly set aria-expanded for consistency
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-open'); // Ensure it's visually open

    // Attach event listeners
    trigger.addEventListener('click', toggle);
    trigger.addEventListener('touchstart', toggle); // Add for mobile
  });

  el.querySelectorAll('.collapsible-content').forEach(module => {
    module.classList.add('is-open'); // Ensure mobile follows desktop behavior
    module.style.maxHeight = module.scrollHeight + 'px';
  });
}


  function toggle(evt) {
    if (isTransitioning) {
      return;
    }

    isTransitioning = true;

    var el = evt.currentTarget;
    var isOpen = el.classList.contains(classes.open);
    var isTab = el.classList.contains(classes.tabs);
    var moduleId = el.getAttribute('aria-controls');
    var container = document.getElementById(moduleId);

    if (!moduleId) {
      moduleId = el.dataset.controls;
    }

    if (!moduleId || !container) {
      isTransitioning = false;
      return;
    }

    var height = container.scrollHeight;
    var isAutoHeight = container.classList.contains(classes.autoHeight);

    if (isOpen) {
      // Collapse the section
      el.setAttribute('aria-expanded', 'false');
      el.classList.remove(classes.open);
      container.classList.remove(classes.open);
      container.style.maxHeight = '0px';
    } else {
      // Expand the section
      el.setAttribute('aria-expanded', 'true');
      el.classList.add(classes.open);
      container.classList.add(classes.open);
      container.style.maxHeight = height + 'px';
    }

    setTimeout(() => {
      isTransitioning = false;
    }, 300);
  }

  return {
    init: init
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  theme.collapsibles.init();
});
